{
  "brandTitle": "VBB PLAY — Jonli yordam",
  "brandShort": "VBB PLAY Yordam",
  "liveLabel": "VBB PLAY Jonli yordam",
  "online": "Onlayn",
  "offline": "Oflayn",
  "close": "Yopish",
  "moreOptions": "Qo‘shimcha",
  "closeChat": "Chatni yopish",
  "closeMenu": "Menyuni yopish",
  "operator": "VBB PLAY operatori",
  "removeFile": "Faylni olib tashlash",
  "attachFile": "Fayl qo‘shish",
  "loadFailed": "Yuklanmadi.",
  "fileTooLarge": "Fayl 50 MB dan katta.",
  "sendFailed": "Xabar yuborilmadi ({{status}})",
  "networkError": "Tarmoq xatosi. Qayta urinib ko‘ring.",
  "nameRequired": "Ismingizni kiriting.",
  "emailInvalid": "To‘g‘ri e-pochta yozing.",
  "topicRequired": "Mavzuni tanlang.",
  "messageRequired": "Muammoni qisqa yozing.",
  "consentRequired": "Maxfiylik roziligi kerak.",
  "requestFailed": "So‘rov yuborilmadi.",
  "messagePlaceholder": "Qisqa izoh…",
  "sending": "Yuborilmoqda…",
  "startLive": "Jonli yordamni boshlash",
  "ratingFailed": "Baholash yuborilmadi.",
  "ratingPlaceholder": "Qisqa fikr (ixtiyoriy)",
  "contactSaveFailed": "Aloqa saqlanmadi.",
  "save": "Saqlash",
  "loginRequired": "Jonli yordamga yozish uchun kiring.",
  "intakeHint": "Tezroq yordam uchun ma’lumotlaringizni kiriting.",
  "back": "Orqaga",
  "yourName": "Ismingiz",
  "yourEmail": "E-pochta manzilingiz",
  "emailPlaceholder": "email@namuna.com",
  "topicLabel": "Mavzu",
  "topicSelect": "Tanlang…",
  "messageLabel": "Muammo yoki xabar",
  "consentLong": "Shaxsiy ma’lumotlar qayta ishlanishiga roziman. Maxfiylik siyosati bilan tanishdim.",
  "soundOff": "🔊 Ovozni o‘chirish",
  "soundOn": "🔇 Ovozni yoqish",
  "rateOperator": "⭐ Operatorni baholash",
  "editContact": "✎ Shaxsiy ma’lumotlarni o‘zgartirish",
  "searchingOperator": "🔎 Operator qidirilmoqda...",
  "waitingOperator": "⏳ So‘rov qabul qilindi. Operatorni kuting.",
  "operatorJoined": "Operator {{name}} chatga qo‘shildi",
  "sendFailedShort": "Yuborilmadi",
  "retry": "Qayta urinish",
  "cameraShot": "📷 Kameradan surat",
  "pickPhoto": "🖼️ Rasm tanlash",
  "pickVideo": "🎬 Video tanlash",
  "pickFile": "📁 Fayl yoki hujjat tanlash",
  "textPlaceholder": "Matn...",
  "messageAria": "Xabar",
  "sendAria": "Yuborish",
  "emojiAria": "Emoji",
  "rateTitle": "Operatorni baholash",
  "submitRate": "Yuborish",
  "editContactTitle": "Shaxsiy ma’lumotlarni o‘zgartirish",
  "cameraPermissionTitle": "Kamera ruxsati",
  "cameraPermissionBody": "Suratga olish uchun kamera ruxsati kerak. Brauzer oynasi qurilma tilida qolishi mumkin.",
  "allowCamera": "Ruxsat berish",
  "notNow": "Hozir emas",
  "namePlaceholder": "Ism",
  "topic_deposit": "Depozit muammosi",
  "topic_withdraw": "Yechib olish muammosi",
  "topic_balance": "Balans muammosi",
  "topic_game": "O‘yin muammosi",
  "topic_bonus": "Bonus muammosi",
  "topic_account": "Hisob / kirish",
  "topic_tech": "Texnik muammo",
  "topic_other": "Boshqa savol",
  "fileOpenFailed": "Fayl ochilmadi: {{name}}",
  "retryShort": "Qayta",
  "fileLoading": "Fayl yuklanmoqda: {{name}}",
  "emoji_smileys": "Yuzlar",
  "emoji_people": "Imo-ishoralar",
  "emoji_nature": "Tabiat",
  "emoji_food": "Ovqat",
  "emoji_activity": "Sport",
  "emoji_travel": "Sayohat",
  "emoji_objects": "Buyumlar",
  "emoji_symbols": "Belgilar",
  "emoji_flags": "Bayroqlar"
}
